/* eslint-disable react/jsx-props-no-spreading */
import React, { TextareaHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  className?: string;
}

const TextareaUnform: React.FC<TextareaProps> = ({ name, ...props }) => {
  const textareaRef = useRef(null);

  const {
    fieldName, defaultValue, error, registerField,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textareaRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <textarea ref={textareaRef} defaultValue={defaultValue} {...props} />
      <span className="text-danger">{error}</span>
    </>
  );
};

TextareaUnform.defaultProps = {
  className: undefined,
};

export default TextareaUnform;
